export const environment = {
  env: 'production',
  production: true,
  appApi: 'https://pregnantwithdiabetes.vercel.app/api/app',
  release: '14982b68f6e09e2141b6b7b46029302edd9b128f',
  dist: 'web',
  environment: 'production',
};
